import { faDiamondExclamation } from "@fortawesome/pro-solid-svg-icons"
import { CircleIcon } from "components/icons/CircleIcon"
import { Box, Checkbox, FormControlLabel, Grid, Switch, TextField, Typography, useTheme } from "@mui/material"
import { useEffect, useState } from "react"
import * as Yup from "yup"

const ViolationSwitch = (props: any) => {
  const { values, setFieldValue, handleChange, handleBlur, errors, touched, editCompany, setValidationStep, t } =
    props

  const [showViolation, setShowViolation] = useState(values.violationActive)
  const [showIdhaImport, setShowIdhaImport] = useState<boolean>(values.violationIdhaImport)
  const [showTachosafe, setShowTachosafe] = useState(values.violationId != null)
  const [selectedRegulations, setSelectedRegulations] = useState(values.violationRegulations)
  const theme = useTheme()
  const regulations = ["2014/165", "2006/561", "2020/1054", "2002/15/EC"]

  useEffect(() => {
    setFieldValue("violationIdhaImport", showIdhaImport)
  }, [showIdhaImport])

  useEffect(() => {
    setFieldValue("violationActive", showViolation)
  }, [showViolation])

  useEffect(() => {
    if (showViolation && showTachosafe) {
      var violationObj = Yup.object().shape({
        violationId: Yup.string().nullable().required(t("global.client_id_is_required", "Client id is required")),
        violationRegulations: Yup.array().of(Yup.string()).min(1, t("global.at_least_one_rule_must_be_selected", "At least one rule must be selected"))
      })
      setValidationStep(violationObj)
    }
  }, [values, showViolation, showTachosafe])

  useEffect(() => {
    setFieldValue("violationRegulations", selectedRegulations)
  }, [selectedRegulations])


  return (
    <>
      <Box mb={3}>
        <Grid container direction="row" justifyContent="space-between" alignItems="center">
          <Grid item xs={2}>
            <CircleIcon icon={faDiamondExclamation} backgroundColor={(theme.palette as any).primary[300]}
              color={(theme.palette as any).primary[900]} size="sm" sx={{ marginRight: "15px" }} />
          </Grid>
          <Grid item xs={8}>
            <Typography fontWeight={600} variant="bodyMedium" color="textPrimary">
              {t("violation.violation", "Violation")}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Switch
              onChange={() => {
                setShowViolation(!showViolation)
              }}
              id="violationActive"
              checked={showViolation}
            />
          </Grid>
        </Grid>
      </Box>

      {showViolation && (
        <>
          <Grid item xs={12} mb={3}>
            <FormControlLabel
              control={
                <Switch
                  onChange={() => {
                    setShowIdhaImport(!showIdhaImport)
                  }}
                  checked={showIdhaImport}
                  id="violationIdhaImport"
                />
              }
              label={t("global.import", "Idha import")}
            />
          </Grid>
          <Grid item xs={12} mb={3}>
            <FormControlLabel
              control={
                <Switch
                  onChange={() => {
                    setShowTachosafe(!showTachosafe)
                  }}
                  checked={showTachosafe}
                  id="tachosafe"
                />
              }
              label={t("global.tacho_integration", "Tacho4Safe integration")}
            />
          </Grid>

          {showTachosafe && (
            <>
              <Grid item xs={12} mb={3}>
                <TextField
                  autoComplete="off"
                  fullWidth
                  id="violationId"
                  label={t("global.client_id", "Client id")}
                  value={values.violationId}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.violationId && errors.violationId ? true : false}
                  helperText={touched.violationId && errors.violationId ? errors.violationId : null}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} mb={3}>
                <Typography variant="bodyMedium" color="textPrimary">
                  {t("global.regulations", "Regulations")}
                </Typography>
                {regulations.map((item: string) => {
                  return (
                    <FormControlLabel
                      key={item}
                      control={
                        <Checkbox
                          onChange={(e) => {
                            setSelectedRegulations((prevState: string[]) => {
                              if (e.target.checked) {
                                return [...prevState, item]
                              } else {
                                return prevState.filter((reg) => reg !== item)
                              }
                            })
                          }}
                          checked={selectedRegulations.some((v: string) => v === item)}
                        />
                      }
                      label={item}
                    />
                  )
                })}
                {errors.violationRegulations && touched.violationRegulations && (
                  <div style={{ color: "red" }}>{errors.violationRegulations}</div>
                )}
              </Grid>
            </>
          )}
        </>
      )}
    </>
  )
}

export default ViolationSwitch
